import dayjs from 'dayjs';
import { useContext, useEffect, useState } from 'react';
import { getSummary } from '|/app/services';
import AppFrameworkContext from '|/helpers/app-framework';
import useAbortController from '../../../helpers/use-abort-controller';
import { getPurchaseStatus } from '../services';

const getNextRoute = async (vehicleId: number, abortSignal: AbortSignal) => {
  const [summary, purchaseStatus] = await Promise.all([
    getSummary(abortSignal),
    getPurchaseStatus(abortSignal)
  ]);
  const {
    vehicle: {
      isAvailable = null,
      id = null,
      unlockDateTime: expiresOn = null
    } = {}
  } = summary || {};
  const { mostRecentSaleDate = null, hasActivePurchase = null } =
    purchaseStatus || {};

  const isLockedTimerPaused =
    expiresOn &&
    new Date(expiresOn).getFullYear() > new Date().getFullYear() + 10;

  const hasBrowserVehicleId = vehicleId != null;
  const hasSavedVehicleId = id != null;
  const doesBrowserVehicleIdMatchSavedVehicleId =
    hasBrowserVehicleId && hasSavedVehicleId && vehicleId === id;

  const recentSaleDate = new Date(mostRecentSaleDate || '');
  const differenceInDays = dayjs().diff(dayjs(recentSaleDate), 'days');
  const isWithin7dmbg = differenceInDays <= 7;

  if (isWithin7dmbg && !hasActivePurchase) {
    return `/vehicle/exchange/${vehicleId}`;
  }

  if (vehicleId !== null && vehicleId === id) {
    return '/';
  }

  if (id !== null && isAvailable === false && vehicleId !== id) {
    return `/vehicle/startpurchase/${vehicleId}?isSwitch=true`;
  }

  if (vehicleId !== null && id === null) {
    return `/vehicle/startpurchase/${vehicleId}`;
  }

  if (
    hasBrowserVehicleId &&
    hasSavedVehicleId &&
    !doesBrowserVehicleIdMatchSavedVehicleId &&
    !isLockedTimerPaused
  ) {
    return `/vehicle/confirmation/${vehicleId}`;
  }

  return `/vehicle/reservation-error`;
};

const useVehiclePurchaseVm = (vehicleIdString: string | null) => {
  const { abortController } = useAbortController();
  const { load } = useContext(AppFrameworkContext);
  const [newRoute, setNewRoute] = useState<string | null>(null);
  useEffect(() => {
    const vehicleId = Number.parseInt(vehicleIdString || '');
    if (Number.isNaN(vehicleId)) {
      return;
    }
    load(
      getNextRoute(vehicleId, abortController.signal).then(nextRoute =>
        setNewRoute(nextRoute)
      ),
      abortController.signal
    );
  }, [load, vehicleIdString, abortController.signal]);

  return {
    newRoute
  };
};

export default useVehiclePurchaseVm;
